module.exports = __webpack_public_path__ + "static/media/birds-eye-village3.bab4a507.jpg";